import React from 'react'
import { makeStyles } from '@material-ui/core'
import type { Theme } from '@material-ui/core/styles'
import type { StyleClasses } from '../../styles'

import IconButton from '@material-ui/core/IconButton'
import FirstPageIcon from '@material-ui/icons/FirstPage'
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft'
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight'
import LastPageIcon from '@material-ui/icons/LastPage'
import Typography from '../Typography'

const useStyles = makeStyles<Theme, TablePaginationProps>(
  (theme) => ({
    root: {
      borderTop: `1px solid ${theme.palette.divider}`,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    wrapper: {
      display: 'flex',
      alignItems: 'center'
    },
    pageLabel: {
      margin: '0 8px'
    }
  }),
  { name: 'TablePagination' }
)

export interface TablePaginationProps {
  classes?: StyleClasses<typeof useStyles>
  currentPage: number
  pages?: number
  disablePrevPage?: boolean
  disableNextPage?: boolean
  disableFirstPage?: boolean
  disableLastPage?: boolean
  showFirstLastPagination?: boolean
  onChangePage: (event: React.MouseEvent<HTMLButtonElement>, page: number) => any
}

function TablePagination(props: TablePaginationProps) {
  const {
    disableFirstPage,
    disableLastPage,
    showFirstLastPagination,
    currentPage,
    pages,
    disablePrevPage,
    disableNextPage,
    onChangePage
  } = props

  const classes = useStyles(props)

  const handlePrevButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => onChangePage(event, currentPage - 1)

  const handleNextButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => onChangePage(event, currentPage + 1)

  const handleFirstButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => onChangePage(event, 1)

  const handleLastButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => onChangePage(event, pages)

  return (
    <div className={classes.root}>
      {showFirstLastPagination && (
        <IconButton disabled={disableFirstPage} aria-label="First Page" onClick={handleFirstButtonClick}>
          <FirstPageIcon />
        </IconButton>
      )}
      <IconButton disabled={disablePrevPage} aria-label="Previous Page" onClick={handlePrevButtonClick}>
        <KeyboardArrowLeft />
      </IconButton>
      <Typography className={classes.pageLabel} variant="subtitle2">
        Page {currentPage} {pages ? `of ${pages}` : ''}
      </Typography>
      <IconButton disabled={disableNextPage} aria-label="Next Page" onClick={handleNextButtonClick}>
        <KeyboardArrowRight />
      </IconButton>
      {showFirstLastPagination && (
        <IconButton disabled={disableLastPage} aria-label="Last Page" onClick={handleLastButtonClick}>
          <LastPageIcon />
        </IconButton>
      )}
    </div>
  )
}

export default TablePagination
